{
  "search-join-attendee-submit-btn": "完了",
  "go-to-package-btn": "購入オプション",
  "done-exit-btn": "完了（キオスク終了）",
  "title-select-package": "パッケージを選択",
  "title-suggest-a-product": "注文に別の商品を追加しますか？",
  "title-choose-a-product": "注文に追加する商品を選択",
  "store-title": "購入したい商品を選択してください",
  "title-shopping-cart": "ショッピングカート",
  "select-images-notice-message": "印刷したい画像を選択してください。",
  "select-images-notice-ok": "OK",
  "confirm-change-img-btn": "OK、この画像を使う",
  "select-image-title": "OCCOプロフィール写真",
  "welcome-title": "フォトアルバム",
  "welcome-event-list-label": "イベント一覧:",
  "welcome-item-count-label": "アイテム数:",
  "select-image-selection-title": "画像を選択（{{count}}）",
  "select-image-step-label": "ステップ {{currentStep}} / {{totalSteps}}",
  "select-image-for-product-text": "「{{title}}」用",
  "select-image-next-btn": "次へ（{{selectedCount}}/{{requiredCount}}）",
  "select-image-clear-btn": "クリア",
  "select-image-no-photos-message": "利用可能な写真がありません",
  "select-image-no-uid-message": "アカウントの特定中に問題が発生しました。もう一度お試しください。",
  "select-image-unlock-notice-message": "アンロックしたい画像を選択してください。",
  "select-image-print-or-unlock-notice-message": "印刷またはアンロックしたい画像を選択してください。",
  "select-image-addon-selection-title": "画像を選択",
  "select-image-addon-done-count-btn": "完了（{{count}}）",
  "select-image-no-compatible-image-message": "互換性のある画像が見つかりませんでした",
  "select-image-photo-limit-message": "印刷したい画像を {{count}} 枚選択してください。",
  "welcome-gallery-title": "マイアルバム",
  "welcome-select-images-of-yourself-title": "ご自身が写っている画像をすべて選択",
  "welcome-select-found-images-title": "ギャラリーに追加したい写真を選択",
  "welcome-back-to-gallery-btn": "アルバムに戻る",
  "checkout-subtotal-label": "小計:",
  "checkout-taxes-label": "税金:",
  "checkout-total-label": "合計:",
  "checkout-btn": "会計へ",
  "checkout-add-on-btn": "+ 追加オプション",
  "checkout-add-product-btn": "商品を追加",
  "checkout-empty-cart-message": "カートは空です",
  "checkout-promo-code-placeholder": "スタッフ専用",
  "checkout-invalid-promo-code-message": "無効または期限切れのプロモーションコードです！",
  "checkout-discount-label": "割引: {{title}}",
  "checkout-receipt-title": "レシート",
  "checkout-receipt-product-label": "商品",
  "checkout-receipt-unit-price-label": "単価",
  "checkout-receipt-qty-label": "数量",
  "checkout-receipt-amount-label": "金額",
  "checkout-digital-package-upsell-message": "デジタルパッケージを<br>ショッピングカートに追加して、<br>すべてのデジタルコンテンツに<br>アクセスしますか？",
  "photo-plus-pass-required-message": "Photo+ Pass をまだお持ちでないようです。<br><br>高解像度コンテンツにアクセスするには、今すぐ入手してください。",
  "photo-plus-valid-ticket-required-message": "ご来園に有効なチケットがまだ確認できません。チケットを連携して Photo+ 体験をお楽しみください。",
  "photo-plus-visit-availability-message": "Photo+ 体験は Genting SkyWorlds ご来園中にご利用いただけます。",
  "checkout-other-products-upsell-message": "デジタルパッケージにプリントを追加しますか？",
  "checkout-delete-restriction-message": "追加オプションを購入する場合、ショッピングカートには少なくとも1つのパッケージを残す必要があります。パッケージを変更する場合は、先に追加オプションをすべて削除してください。",
  "checkout-digital-package-duplicate-message": "ショッピングカートにはすでにデジタルアクセスパッケージがあります。<br>現在のパッケージを削除または購入するまで、新しいパッケージは追加できません。",
  "welcome-print-modal-title": "印刷",
  "welcome-print-modal-text": "写真は印刷され、イベント主催者に引き渡されます。",
  "cancel-btn": "キャンセル",
  "welcome-preview-modal-title": "プレビュー",
  "close-btn": "閉じる",
  "ok-btn": "確認",
  "back-btn": "戻る",
  "info-title": "お知らせ",
  "apply-btn": "適用",
  "clear-btn": "クリア",
  "yes-btn": "はい",
  "no-btn": "いいえ",
  "change-image-btn": "画像を変更",
  "done-btn": "完了",
  "skip-btn": "スキップ",
  "refresh-btn": "更新",
  "exit-btn": "終了",
  "unsupported-picture-format-message": "無効または未対応の画像形式です",
  "welcome-alert-modal-title": "モーダルタイトル",
  "welcome-alert-modal-body-text": "ここにモーダル本文が表示されます。",
  "welcome-alert-save-btn": "変更を保存",
  "welcome-passcodes-modal-title": "パスコードを生成",
  "welcome-passcodes-events-label": "パスコードを生成するイベントを選択してください:",
  "welcome-passcodes-email-label": "XLS形式のパスコード受信用メールアドレス:",
  "welcome-passcodes-count-label": "生成するパスコード数:",
  "welcome-passcodes-count-help": "1〜200,000の数値",
  "welcome-passcodes-prepaid-label": "これらのカード保有者を前払い/VIPとして扱いますか？:",
  "welcome-passcodes-expiry-label": "公開キオスクへのアクセス有効期限（分）（無効化する場合は0）:",
  "welcome-passcodes-url-prefix-label": "アルバムアクセスURLのプレフィックス（例: https://domain-name.com）:",
  "welcome-passcodes-generate-btn": "生成",
  "sharing-modal-title": "画像を共有",
  "sharing-tab-email": "メール",
  "sharing-tab-sms": "SMS",
  "sharing-email-name-placeholder": "氏名",
  "sharing-email-placeholder": "有効なメールアドレス",
  "sharing-email-help-text": "複数のメールアドレスは、セミコロン・カンマ・スペース・Enterで区切って入力してください。",
  "sharing-contact-phone-placeholder": "電話番号",
  "sharing-company-placeholder": "会社・機関名",
  "sharing-sms-name-placeholder": "氏名",
  "sharing-sms-phone-placeholder": "有効な電話番号",
  "sharing-privacy-link": "プライバシーポリシー",
  "sharing-privacy-prefix": "お客様のプライバシーは非常に重要です。以下をご確認ください",
  "welcome-delete-modal-title": "削除",
  "welcome-delete-modal-body": "この写真をアルバムから削除してもよろしいですか？",
  "welcome-delete-photo-confirmation-message": "本当にこの画像をアルバムから削除しますか？",
  "welcome-delete-photo-keep-btn": "この画像を残す！",
  "welcome-delete-photo-delete-btn": "この画像をアルバムから削除",
  "welcome-delete-reason-not-mine-btn": "はい。これは私の写真ではありません",
  "welcome-delete-confirm-btn": "削除",
  "welcome-selfie-modal-title": "顔で自分の画像を検索",
  "welcome-selfie-match-found-title": "見つかった可能性があります！",
  "welcome-selfie-match-found-confirm-message": "あなたの画像をタップして確認してください。",
  "welcome-selfie-capture-btn": "ここをクリック",
  "welcome-delete-reason-dont-want-btn": "はい。私の写真ですが不要です",
  "welcome-print-copy-count-label": "印刷枚数を選択",
  "catalog-select-product-package-title": "商品パッケージを選択",
  "freedompay-offline-request-title": "オフライン取引リクエストIDを入力してください",
  "square-reader-access-token-title": "Square Access Token を入力してください",
  "square-reader-pairing-code-title": "このコードを使って新しい Square リーダーにサインインし、完了後に OK を押してください。",
  "square-reader-still-unpaired-text": "この端末はまだペアリングされていません。コードを使用して新しい Square リーダーにサインインしてください。",
  "square-reader-security-note-title": "セキュリティ上の理由で保存されないため、次の2つのキーを控えてください",
  "storicard-invalid-code-text": "無効な StoriCard コードです。",
  "header-menu-user-id-link": "UserID:",
  "countdown-time-up-text": "時間切れです！",
  "welcome-find-more-images-btn": "画像をさらに探す",
  "welcome-select-images-btn": "画像を選択",
  "welcome-selected-images-next-btn": "この {{count}} 枚の画像に写っているのは私です。次へ >",
  "welcome-invalid-attendee-id-message": "無効な attendee ID です。",
  "welcome-kiosk-time-expired-message": "公開キオスクの利用時間が終了しました",
  "welcome-grouping-error-message": "3日以上前に作成されたアカウントのグループ化は許可されていません。",
  "confirm-btn": "確認",
  "approved-btn": "承認済み",
  "checkout-confirm-purchase-title": "購入内容をご確認ください",
  "checkout-confirm-purchase-short-title": "購入確認",
  "checkout-digital-access-summary": "本日撮影したすべてのデジタル画像へのアクセス",
  "checkout-and-text": "と",
  "checkout-print-count-summary": "{{count}} 枚プリント",
  "checkout-digitals-copy-message": "デジタルデータのコピーを作成しますか？<br>カード紛失時のためにおすすめします。",
  "checkout-email-placeholder": "メールアドレス",
  "checkout-email-or-phone-placeholder": "メールアドレスまたは米国の電話番号",
  "checkout-sms-agreement-label": "上記の電話番号宛てに Storibox から通知メッセージを受け取ることに同意します。画像に関する更新情報やリンクを含む SMS を受信することを理解しています。通信料・メッセージ料金が発生する場合があります。停止するには STOP と返信してください。",
  "checkout-name-placeholder": "お名前",
  "checkout-cancel-transaction-btn": "取引をキャンセル",
  "checkout-employee-authorization-title": "従業員の認証が必要です",
  "checkout-scan-employee-card-prefix": "次の取引が完了したら従業員カードをスキャンしてください:",
  "checkout-transaction-complete-suffix": "が完了しました",
  "checkout-unlock-code-error-message": "従業員認証コードが無効です。",
  "checkout-printing-now-title": "印刷中",
  "checkout-prints-ready-message": "印刷物は1分ほどで準備できます",
  "checkout-digitals-unlocked-message": "デジタル写真のロックが解除されました",
  "checkout-internal-error-title": "申し訳ありません。内部エラーが発生しました",
  "checkout-transaction-processed-title": "取引が完了しました！",
  "checkout-register-receipt-qr-message": "デジタルレシートとアルバムリンクを受け取るため、QRをスキャンして登録してください！",
  "checkout-shop-more-btn": "さらに購入",
  "checkout-print-receipt-btn": "レシートを印刷",
  "checkout-paid-by-cash-label": "現金払い",
  "checkout-paid-by-card-label": "カード払い",
  "checkout-draft-order-error-message": "下書き注文の作成に失敗しました。",
  "checkout-print-confirmation-message": "印刷商品をご注文の場合、1分ほどで準備できます。商品は販売カウンターでお受け取りください",
  "checkout-shopify-params-incomplete-message": "Shopify パラメータが不完全です",
  "checkout-event-name-required-message": "eventName が指定されていません。",
  "payment-no-device-connected-message": "接続されているデバイスがありません。",
  "payment-ask-for-assistance-message": "スタッフにお声がけください。",
  "payment-square-checkout-creation-failed-message": "会計リクエストに失敗しました。しばらくしてから再度お試しください。",
  "payment-square-checkout-status-check-failed-message": "会計ステータスの確認に失敗しました。しばらくしてから再度お試しください。",
  "payment-qr-title": "スマートフォンで支払う",
  "payment-qr-help-html": "<b>簡単・スピーディ:</b><br> 上のQRコードをスキャンして、画面の案内に従ってください。",
  "payment-qr-transaction-progress-message": "取引を処理中です...",
  "payment-qr-failed-message": "QR決済に失敗しました。APIキーを確認して再度お試しください。",
  "payment-failed-message": "お支払いに失敗しました。しばらくしてから再度お試しください。",
  "payment-failed-short-message": "お支払いに失敗しました。",
  "payment-use-pinpad-message": "取引を完了するには PinPad をご利用ください...",
  "payment-terminal-progress-message": "取引を処理中です。<br>キャンセルするには、端末の矢印をタップしてください。",
  "payment-transaction-canceled-message": "取引はキャンセルされました。",
  "search-version-label": "kiosk v.{{version}}",
  "search-find-by-qr-btn": "QRで検索",
  "search-find-by-face-btn": "顔で検索",
  "search-scan-another-qr-placeholder": "別のQRコードをスキャン",
  "search-scanned-attendee-label": "スキャン済み: {{attId}}",
  "search-qr-or-photos-not-found-message": "QRコードまたは写真が見つかりません。もう一度スキャンしてください。",
  "scanning-qr-page-title": "フォトアルバム",
  "photo-viewer-back-btn": "アルバムに戻る"
}
